import { Card, Space } from 'antd';
import React, { useEffect } from 'react';
import { DynamicObjectType } from 'types/commons';
import ProductsOrder from './ProductsOrder';
import OtherInformation from './OtherInformation';
import OrderHistories from './OrderHistories';
import { useDispatch } from '@redux';
import { getAllOrderHistories } from '@redux/orderHistories/actions';
import PaymentInformation from './PaymentInformation';
import { CardWrapper } from './styles';

const LeftContent = ({ data }: { data: DynamicObjectType }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (data?.id) {
      dispatch(
        getAllOrderHistories({
          data: {
            pageSize: 100,
            join: ['creator'],
            filters: [
              {
                key: 'orderId',
                condition: 'and',
                value: data?.id,
                operator: 'eq',
              },
            ],
            orderBy: '-createdAt',
          },
          options: {
            isRefresh: true,
          },
        }),
      );
    }
  }, [data]);

  return (
    <div>
      <Space size={20} direction="vertical" className="w-full">
        <Card title="Product information">
          <ProductsOrder
            isRejectReturn
            data={data}
            items={data?.items}
            fulfillmentInspection={data?.fulfillmentInspection}
          />
        </Card>
        <CardWrapper title="Payment Information">
          <PaymentInformation data={data} />
        </CardWrapper>
        <Card title="Other information">
          <OtherInformation data={data} />
        </Card>
        <OrderHistories />
      </Space>
    </div>
  );
};

export default LeftContent;
